/* Lorelia — Live-Vorschau fuer Fotogeschenke
 *
 * Legt das Kundenfoto perspektivisch auf ein echtes Produktfoto, statt es
 * flach vor merchOnes Katalogbild zu setzen. Das Foto kommt aus teeinblues
 * Vorschau-SVG; sobald der Kunde es wechselt oder zuschneidet, zeichnen wir neu.
 *
 * Je Produkt braucht es einen Eintrag in LR_FOTO: das leere Produktbild und
 * die vier Ecken der Druckflaeche darin (im Pixelraster des Produktbildes,
 * im Uhrzeigersinn ab oben links). Bei runden Flaechen legen wir das Foto
 * einfach darueber und schneiden mit `radius` bzw. `rund` ab.
 */
(function () {
  'use strict';
  var KONF = window.LR_FOTO_KONF || {};
  var nurGalerie = !KONF.bild || !KONF.ecken;   // Produkt ohne eigene Vorschau

  var D = document, halter = null, bildEl = null, letzteQuelle = '';

  /* --- Homographie: Einheitsrechteck -> vier Zielpunkte --------------- */
  function homographie(w, h, p) {
    var q = [[0, 0], [w, 0], [w, h], [0, h]], A = [], b = [];
    for (var i = 0; i < 4; i++) {
      var x = q[i][0], y = q[i][1], u = p[i][0], v = p[i][1];
      A.push([x, y, 1, 0, 0, 0, -u * x, -u * y]); b.push(u);
      A.push([0, 0, 0, x, y, 1, -v * x, -v * y]); b.push(v);
    }
    // Gauss mit Spaltenpivot
    for (var c = 0; c < 8; c++) {
      var max = c;
      for (var r = c + 1; r < 8; r++) if (Math.abs(A[r][c]) > Math.abs(A[max][c])) max = r;
      var t = A[c]; A[c] = A[max]; A[max] = t;
      var tb = b[c]; b[c] = b[max]; b[max] = tb;
      if (!A[c][c]) return null;
      for (var r2 = c + 1; r2 < 8; r2++) {
        var f = A[r2][c] / A[c][c];
        for (var k = c; k < 8; k++) A[r2][k] -= f * A[c][k];
        b[r2] -= f * b[c];
      }
    }
    var s = new Array(8);
    for (var i2 = 7; i2 >= 0; i2--) {
      var sum = b[i2];
      for (var j = i2 + 1; j < 8; j++) sum -= A[i2][j] * s[j];
      s[i2] = sum / A[i2][i2];
    }
    return s; // a b c d e f g h  ->  [[a,b,c],[d,e,f],[g,h,1]]
  }

  function matrix3d(s) {
    return 'matrix3d(' + [
      s[0], s[3], 0, s[6],
      s[1], s[4], 0, s[7],
      0, 0, 1, 0,
      s[2], s[5], 0, 1
    ].join(',') + ')';
  }

  /* --- Das Kundenfoto aus teeinblues Vorschau holen ------------------- */
  function quelleSuchen() {
    // teeinblue haengt das Artwork-SVG ausserhalb der Galerie ein
    var svg = D.querySelector('svg[id^="tee-artwork-"]')
           || D.querySelector('svg.tee-mockup-artwork')
           || D.querySelector('svg.tee-printarea-artwork');
    if (!svg) return '';
    var bilder = svg.querySelectorAll('image');
    var beste = '', flaeche = 0;
    for (var i = 0; i < bilder.length; i++) {
      var b = bilder[i];
      var href = b.getAttribute('href') || b.getAttribute('xlink:href') || '';
      if (!href || href.indexOf('placehold') > -1) continue;
      var f = (parseFloat(b.getAttribute('width')) || 0) * (parseFloat(b.getAttribute('height')) || 0);
      if (f >= flaeche) { flaeche = f; beste = href; }
    }
    return beste;
  }

  /* --- Bildergalerie aus den Shopify-Produktbildern --------------------
   * teeinblue ersetzt Shopifys eigene Galerie und laesst sie eingeklappt
   * zurueck. Deshalb bauen wir sie selbst: sie zeigt genau die Bilder, die
   * im Shopify-Produkt hinterlegt sind — und tritt im Gestalter zurueck.  */
  var galerieDa = false;
  function galerie() {
    var bilder = window.LR_FOTO_BILDER || [];
    var ziel = D.querySelector('.product-information__media');
    if (galerieDa || !ziel || !bilder.length) return;
    galerieDa = true;
    var g = D.createElement('div');
    g.className = 'lr-gal';
    g.innerHTML =
      '<div class="lr-gal-gross"><img src="' + bilder[0] + '" alt=""></div>' +
      (bilder.length > 1
        ? '<div class="lr-gal-leiste">' + bilder.map(function (b, i) {
            return '<button type="button" class="lr-gal-mini' + (i ? '' : ' an') +
                   '"><img src="' + b + '" alt="" loading="lazy"></button>';
          }).join('') + '</div>'
        : '');
    ziel.insertBefore(g, ziel.firstChild);
    g.addEventListener('click', function (e) {
      var b = e.target.closest('.lr-gal-mini');
      if (!b) return;
      var i = [].indexOf.call(g.querySelectorAll('.lr-gal-mini'), b);
      g.querySelector('.lr-gal-gross img').src = bilder[i];
      g.querySelectorAll('.lr-gal-mini').forEach(function (m) { m.classList.remove('an'); });
      b.classList.add('an');
    });
    D.body.classList.add('lr-gal-an');
  }

  /* --- Aufbau --------------------------------------------------------- */
  function aufbauen() {
    var ziel = D.querySelector('.product-information__media');
    if (!ziel || halter) return;
    halter = D.createElement('div');
    halter.className = 'lr-fv';
    halter.innerHTML =
      '<div class="lr-fv-buehne">' +
        '<img class="lr-fv-produkt" src="' + KONF.bild + '" alt="">' +
        '<div class="lr-fv-flaeche"><img class="lr-fv-foto" alt=""></div>' +
        '<img class="lr-fv-oben" alt="" hidden>' +
      '</div>';
    ziel.insertBefore(halter, ziel.firstChild);
    bildEl = halter.querySelector('.lr-fv-foto');
    // Der Gestalter aendert die Groesse der Vorschau (CSS zoom, Reiterwechsel).
    // Ohne diesen Beobachter bliebe die Flaeche auf der alten Groesse stehen.
    if (window.ResizeObserver) {
      new ResizeObserver(function () { legen(); }).observe(halter.querySelector('.lr-fv-buehne'));
    }
    halter.querySelector('.lr-fv-produkt').addEventListener('load', legen);
    if (KONF.oben) { var o = halter.querySelector('.lr-fv-oben'); o.src = KONF.oben; o.hidden = false; }
    D.body.classList.add('lr-fv-an');
    legen();
  }

  /* --- Foto in die Flaeche legen -------------------------------------- */
  function legen() {
    if (!halter) return;
    var buehne = halter.querySelector('.lr-fv-buehne');
    var flaeche = halter.querySelector('.lr-fv-flaeche');
    var B = KONF.groesse[0], H = KONF.groesse[1];
    var produkt = halter.querySelector('.lr-fv-produkt');
    var breite = produkt.clientWidth || buehne.clientWidth;
    if (!breite) return;                      // noch nicht im Layout
    var k = breite / B;                       // Produktbild ist skaliert
    var p = KONF.ecken.map(function (e) { return [e[0] * k, e[1] * k]; });

    // Das Foto wird im Seitenverhaeltnis der Druckflaeche aufgezogen und
    // dann auf die vier Ecken abgebildet (Ecken duerfen abgeschnitten werden).
    var w = Math.hypot(p[1][0] - p[0][0], p[1][1] - p[0][1]);
    var h = Math.hypot(p[3][0] - p[0][0], p[3][1] - p[0][1]);
    flaeche.style.width = w + 'px';
    flaeche.style.height = h + 'px';
    var rel = p.map(function (e) { return [e[0] - p[0][0], e[1] - p[0][1]]; });
    var s = homographie(w, h, rel);
    if (!s) return;
    flaeche.style.transform = 'translate(' + p[0][0] + 'px,' + p[0][1] + 'px) ' + matrix3d(s);
    if (KONF.radius) flaeche.style.borderRadius = (KONF.radius * k) + 'px';
    if (KONF.rund) flaeche.style.borderRadius = '50%';
  }

  function aktualisieren() {
    if (nurGalerie) return;
    var q = quelleSuchen();
    if (!q) return;
    aufbauen();
    if (q !== letzteQuelle && bildEl) { letzteQuelle = q; bildEl.src = q; }
    legen();
  }

  /* --- Beobachten: Foto wechseln, zuschneiden, Fenster drehen --------- */
  function start() {
    galerie();
    var gi = setInterval(function () { galerie(); if (galerieDa) clearInterval(gi); }, 400);
    aktualisieren();
    var mo = new MutationObserver(function () { clearTimeout(start._t); start._t = setTimeout(aktualisieren, 60); });
    mo.observe(D.body, { subtree: true, childList: true, attributes: true,
                         attributeFilter: ['href', 'xlink:href', 'width', 'height', 'style'] });
    window.addEventListener('resize', function () { clearTimeout(start._r); start._r = setTimeout(legen, 80); });
    setInterval(aktualisieren, 1200);          // Sicherheitsnetz gegen verpasste Aenderungen
  }

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', start);
  else start();
})();
